import React, { useEffect } from 'react';
import { Image, Text } from '@user-portal/wikr-components';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectSubscriptions } from 'store/subscriptions/selectors';
import { openModal } from 'store/modals/actions';

import {
  OfferTypes,
  cancelFlow_cancelOfferClick,
  cancelFlow_cancelOfferScreenLoad,
} from 'services/analytics/trackers/cancelFlow';

import { usePauseSubscription, useSelector, useCancelSubscription, useModals } from 'hooks';

import OutlinedButton from 'components/OutlinedButton';
import ModalHeader from 'components/ModalHeader/ModalHeader';
import Modal from 'components/Modal';
import { Button } from 'components/library';

import * as S from './styled';

import presentImg from './img/present.webp';

import { ModalName } from 'types/modals';

const FreeMonthModalContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { closeModal } = useModals();

  const { cancellationCandidate } = useSelector(selectSubscriptions);

  const { discardCancellation, onCancelSubscription } = useCancelSubscription();
  const { onGetFreeMonthPause } = usePauseSubscription();

  useEffect(() => {
    if (cancellationCandidate) {
      cancelFlow_cancelOfferScreenLoad({
        offer_type: OfferTypes.Free_month,
        subscription_id: cancellationCandidate.external_id,
      });
    }
  }, [cancellationCandidate]);

  if (!cancellationCandidate) {
    return null;
  }

  const handleOfferApply = () => {
    onGetFreeMonthPause();

    if (cancellationCandidate) {
      cancelFlow_cancelOfferClick({
        action: 'claim_offer',
        subscription_id: cancellationCandidate.external_id,
        offer_type: OfferTypes.Free_month,
      });
    }
  };

  const handleCancel = () => {
    onCancelSubscription();

    if (cancellationCandidate) {
      cancelFlow_cancelOfferClick({
        action: 'cancel',
        subscription_id: cancellationCandidate.external_id,
        offer_type: OfferTypes.Free_month,
      });
    }
  };

  const goBack = () => {
    dispatch(openModal(ModalName.REASON_MODAL));
  };

  const handleClose = () => {
    closeModal();
    discardCancellation();

    if (cancellationCandidate) {
      cancelFlow_cancelOfferClick({
        action: 'close',
        subscription_id: cancellationCandidate.external_id,
        offer_type: OfferTypes.Free_month,
      });
    }
  };

  return (
    <Modal isOpen fullscreen>
      <>
        <ModalHeader onBack={goBack} onClose={handleClose} />
        <S.Container dataLocator="freeMonthOfferContainer">
          <Image alt="present" src={presentImg} maxWidth={200} center />
          <S.ContentBlock>
            <Text type="h4" medium mb={20} center>
              {t('subscription.cancellation.monthFreeOffer.title')}
            </Text>
            <Text type="large-text" mb={8} center>
              {t('subscription.cancellation.monthFreeOffer.text')}
            </Text>
            <Text type="h6" medium mb={16} center>
              {t('subscription.cancellation.monthFreeOffer.offer')}
            </Text>
          </S.ContentBlock>
          <Button onClick={handleOfferApply} dataLocator="freeMonthGetFree1MonthButton">
            {t('subscription.cancellation.monthFreeOffer.getFreeMonthBtnText')}
          </Button>
          <OutlinedButton dataLocator="freeMonthCancelSubscriptionButton" onClick={handleCancel}>
            {t('subscription.text.cancel')}
          </OutlinedButton>
        </S.Container>
      </>
    </Modal>
  );
};

export default FreeMonthModalContainer;
